import React from "react";
import { Clear } from "@material-ui/icons";
import PropTypes from "prop-types";
import { makeStyles, createStyles, Grid, Button, withStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    createReportContentContainer: {
      position: "relative",
      width: "100%",
      height: "100%",
      maxWidth: "1600px",
      maxHeight: "930px",
      zIndex: "10",
      background: "#fff",
      borderRadius: "20px",
      overflow: "hidden",
    },
    headerBar: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "25px 35px",
    },
    headerBarTitle: {
      color: "black",
      fontFamily: theme.typography.secondary,
      fontWeight: "700",
      fontSize: "24px",
      margin: "0px",
      width: "100%",
      textAlign: "center",
      marginLeft: "32px",
    },
    headerBarIcon: {
      color: "#282828",
      fontSize: "32px",
      cursor: "pointer",
    },
    topGrid: {
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
    subTitle: {
      fontWeight: "700",
      fontSize: "16px",
      fontFamily: " nunito",
      color: "#A3A3A3",
      maxWidth: "337px",
      textAlign: "center",
    },
    properties: {
      fontFamily: theme.typography.secondary,
      fontWeight: "700",
      fontSize: "24px",
      color: "#009EEB",
      marginTop: "56px",
      marginBottom: "54px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "75px 0px 40px",
    },
    image: {
      width: "100%",
      maxWidth: "70px",
    },
    numberHolder: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    svg: {
      marginLeft: "10px",
      marginTop: "52px",
    },
    arrowParent: {
      filter: "drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25))",
    },
    arrowBox: {
      display: "flex",
      top: "-19px",
      left: "22px",
      position: "absolute",
      width: "218px",
      background: "#FFFFFF",
      borderRadius: "10px",
      fontFamily: "nunito",
      fontWeight: "600",
      fontSize: "13px",
      "&::after": {
        content: `''`,
        position: "absolute",
        top: "62%",
        right: "100%",
        width: "0",
        height: "0",
        border: "solid transparent",
        borderColor: "rgba(136, 183, 213, 0)",
        borderRightColor: "#FFFFFF",
        marginTop: "-30px",
        borderWidth: "15px",
      },
    },
    arrowText: {
      color: "#A3A3A3",
      padding: "15px 0px 13px 18px",
    },
    tootTipClose: {
      padding: "9px 9px 0px 0px",
      color: "#AAAAAA",
      fontSize: "27px",
      cursor: "pointer",
    },
    noSvg: {
      display: "none",
    },
    "@media (max-width: 600px)": {
      headerBarTitle: {
        fontSize: "18px",
      },
      headerBarIcon: {
        fontSize: "24px",
      },
    },
  })
);

const EditButton = withStyles((theme) => ({
  root: {
    color: "#fff",
    background: theme.palette.areaPulseBlue,
    fontSize: "16px",
    fontFamily: theme.typography.secondary,
    fontWeight: "700",
    padding: "11px 49.5px",
    borderRadius: "10px",
    transition: "0.2s",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      background: theme.palette.areaPulseBlue,
      transition: "0.2s",
      opacity: "0.8",
    },
  },
}))(Button);

const CreateReportNoReports = ({ setResultsOpen }) => {
  const classes = useStyles();

  return (
    <div className={classes.createReportContentContainer}>
      <div className={classes.headerBar}>
        <h1 className={classes.headerBarTitle}>Oops...something went wrong!</h1>
        <Clear
          fontSize="inherit"
          color="inherit"
          onClick={() => {
            setResultsOpen(false);
          }}
          className={classes.headerBarIcon}
        />
      </div>
      <Grid className={classes.topGrid} container>
        <div className={classes.subTitle}>With the information you provided, your report is showing</div>
        <div className={classes.numberHolder}>
          <div className={classes.properties}>0 properties</div>
        </div>
        <img alt="report-results" className={classes.image} src="/assets/report-results-3.png" />
        <div className={classes.buttonContainer}>
          <EditButton
            onClick={() => {
              setResultsOpen(false);
            }}
          >
            GO BACK
          </EditButton>
        </div>
      </Grid>
    </div>
  );
};

CreateReportNoReports.propTypes = {
  setResultsOpen: PropTypes.func,
};

export default CreateReportNoReports;
